"use client";

import Image from "next/image";
import { ImageAtomProps } from "./Image.types";
import assetLoader from "@utils/internalImageLoder";

const ImageAtom = ({
  src,
  alt = "image",
  width,
  height,
  className = "",
  fill,
  priority = false,
  loading,
}: ImageAtomProps) =>
  src &&
  (priority ? (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      fill={fill}
      fetchPriority={'high'}
      loading={loading ?? "eager"}
      onError={(e) => {
        (e.target as HTMLImageElement).src = `${assetLoader()}/images/placeHolder-FallbackImage.png`;
      }}
    />
  ) : (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      fill={fill}
      loading={loading ?? "lazy"}
      onError={(e) => {
        (e.target as HTMLImageElement).src = `${assetLoader()}/images/placeHolder-FallbackImage.png`;
      }}
    />
  ));

export default ImageAtom;
